import { AppCardMedia } from '@app/components/base/app-card';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { FragmentCardMediaOverlay } from '../base/FragmentCardMediaOverlay';
import { PosterVariant } from '../hooks/useFragmentPosterPolling';
import { FragmentCardPosterWithPolling } from './FragmentCardPosterWithPolling';

/**
 * Media area for video fragment: poster image with overlay (time, statuses, duration)
 * and optional dev-only variant chip.
 * Wrapped in AppCardMedia with 16:9 aspect ratio so the media never stretches in compact/small grids.
 */
export function VideoFragmentMedia({
  fragment,
  posterSrc,
  variant,
}: {
  fragment: FragmentListItemDto;
  posterSrc: string | null;
  variant: PosterVariant | null;
}) {
  return (
    <AppCardMedia sx={{ aspectRatio: '16/9', overflow: 'hidden' }}>
      <FragmentCardMediaOverlay fragment={fragment} sx={{ width: '100%', height: '100%' }}>
        <FragmentCardPosterWithPolling
          fragmentId={fragment.id}
          posterSrc={posterSrc}
          variant={variant}
        />
        {/* <VideoFragmentVariantChip variant={variant} /> */}
      </FragmentCardMediaOverlay>
    </AppCardMedia>
  );
}
